import React from 'react';
import { OCRContainer } from './OcrOverlays.component';
import { useOcrTraining } from './useOcrTraining.hook';
export const OCRReturnOverlay = () => {
    const { isLoadingOcrTraining } = useOcrTraining();
    return (React.createElement(OCRContainer, { hidden: !isLoadingOcrTraining },
        React.createElement("img", { alt: "Purple sparkle animation", className: "w-[75px] h-[75px]", src: `${process.env.REACT_APP_STATIC_BASE_PATH}/images/item-create/ai-item-create--loading.gif` }),
        React.createElement("span", { className: "mt-8 text-black text-base" }, "Applying learnings to your payable...")));
};
